import styled from 'styled-components';

const Wrapper = styled.main`
  background: var(--clr-background, #f6f8f8);
  min-height: 100vh;

  /* Breadcrumb Section - Olive Gradient like Products Page */
  .breadcrumb-section {
    background: linear-gradient(135deg, var(--clr-olive, #6b7b5c) 0%, #5a6b4d 50%, #4a5a3d 100%);
    padding: 7.5rem 0 2rem;
    margin-bottom: 0;
    position: relative;
    overflow: hidden;
  }

  @media (min-width: 768px) {
    .breadcrumb-section {
      padding: 8.5rem 0 2.5rem;
    }
  }

  @media (min-width: 1024px) {
    .breadcrumb-section {
      padding: 9rem 0 3rem;
    }
  }

  /* Decorative elements */
  .breadcrumb-section::before {
    content: '';
    position: absolute;
    top: -50px;
    right: -50px;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
    pointer-events: none;
  }

  .breadcrumb-section::after {
    content: '';
    position: absolute;
    bottom: -80px;
    left: -80px;
    width: 250px;
    height: 250px;
    border-radius: 50%;
    background: rgba(201, 169, 98, 0.08);
    pointer-events: none;
  }

  .breadcrumb-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
    position: relative;
    z-index: 1;
  }

  @media (min-width: 768px) {
    .breadcrumb-container {
      padding: 0 2rem;
    }
  }

  @media (min-width: 1024px) {
    .breadcrumb-container {
      padding: 0 3rem;
    }
  }

  .breadcrumb {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.7);
    font-family: var(--font-body);

    @media (min-width: 768px) {
      font-size: 0.875rem;
    }

    a {
      color: rgba(255, 255, 255, 0.7);
      text-decoration: none;
      transition: color 0.2s;
      font-weight: 500;

      &:hover {
        color: rgba(255, 255, 255, 0.95);
      }
    }

    span {
      color: rgba(255, 255, 255, 0.5);
    }

    span.current {
      color: rgba(255, 255, 255, 0.95);
      font-weight: 600;
    }
  }

  @media (max-width: 767px) {
    .breadcrumb {
      display: none;
    }
  }

  .back-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.95);
    font-size: 0.875rem;
    font-weight: 600;
    text-decoration: none;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 0.5rem;
    transition: all 0.2s;
    font-family: var(--font-body);
    backdrop-filter: blur(10px);

    svg {
      transition: transform 0.2s;
      font-size: 0.75rem;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      border-color: rgba(255, 255, 255, 0.4);
      color: #ffffff;
      
      svg {
        transform: translateX(-2px);
      }
    }
  }

  @media (min-width: 768px) {
    .back-btn {
      padding: 0.625rem 1.25rem;
      font-size: 0.9rem;
    }
  }

  /* Product Section */
  .product-section {
    max-width: 1280px;
    margin: 0 auto;
    padding: 2rem 1.5rem 4rem;
  }

  @media (min-width: 768px) {
    .product-section {
      padding: 3rem 1.5rem 5rem;
    }
  }

  .product-center {
    display: grid;
    gap: 2rem;
  }

  @media (min-width: 1024px) {
    .product-center {
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
    }
  }

  /* Product Images */
  .product-images {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }

  .main-image-container {
    position: relative;
    width: 100%;
    aspect-ratio: 3 / 4;
    overflow: hidden;
    border-radius: 1rem;
    background: #f5f3f0;
  }

  @supports not (aspect-ratio: 3 / 4) {
    .main-image-container {
      padding-bottom: 133%;
      height: 0;
    }
    
    .main-image-container .main-image {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .main-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: transform 0.7s ease;
  }

  video.main-image {
    object-fit: contain;
    background: #000;
  }

  .main-image-container:hover .main-image {
    transform: scale(1.05);
  }

  .badges {
    position: absolute;
    top: 1rem;
    left: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    z-index: 10;
  }

  .badge {
    padding: 0.375rem 0.875rem;
    background: var(--clr-olive, #6b7b5c);
    color: #ffffff;
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .badge.sale {
    background: #dc2626;
  }

  .wishlist-btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 10;
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(4px);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    svg {
      font-size: 1.125rem;
      color: #6b7280;
      transition: all 0.2s;
    }

    &:hover {
      transform: scale(1.1);
    }

    &.active svg {
      color: #dc2626;
      fill: #dc2626;
    }
  }

  .thumbnail-gallery {
    display: flex;
    gap: 0.75rem;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 0.5rem;

    /* Hide scrollbar for clean look but keep functionality */
    scrollbar-width: thin;
    scrollbar-color: rgba(0,0,0,0.15) transparent;

    &::-webkit-scrollbar {
      height: 4px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0,0,0,0.15);
      border-radius: 4px;
    }
  }

  .thumbnail {
    position: relative;
    min-width: 72px;
    width: 72px;
    height: 72px;
    flex-shrink: 0;
    scroll-snap-align: start;
    overflow: hidden;
    border-radius: 0.5rem;
    cursor: pointer;
    border: 2px solid transparent;
    background: #f5f3f0;
    transition: all 0.2s;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.7;
      transition: opacity 0.2s;
    }

    &:hover img {
      opacity: 1;
    }

    &.active {
      border-color: var(--clr-olive, #6b7b5c);
      box-shadow: 0 0 0 2px var(--clr-olive, #6b7b5c);
      
      img, video {
        opacity: 1;
      }
    }

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.7;
      transition: opacity 0.2s;
    }

    &:hover video {
      opacity: 1;
    }

    &.video-thumbnail {
      position: relative;

      .play-overlay {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        font-size: 1.5rem;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
      }
    }
  }

  /* Product Content */
  .content {
    display: flex;
    flex-direction: column;
  }

  .product-title {
    font-family: 'Playfair Display', serif;
    font-size: 1.75rem;
    font-weight: 700;
    color: #111718;
    margin: 0 0 0.75rem;
    line-height: 1.2;
  }

  @media (min-width: 768px) {
    .product-title {
      font-size: 2.25rem;
    }
  }

  @media (min-width: 1024px) {
    .product-title {
      font-size: 2.5rem;
    }
  }

  .rating-section {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;

    .stars {
      display: flex;
      gap: 0.125rem;
      color: #C9A962;
      font-size: 1rem;
    }

    .review-count {
      font-size: 0.875rem;
      color: #6b7280;
    }
  }

  .price-section {
    display: flex;
    align-items: baseline;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
  }

  .price {
    font-family: 'Playfair Display', serif;
    font-size: 1.75rem;
    font-weight: 600;
    color: var(--clr-olive, #6b7b5c);
    margin: 0;
  }

  @media (min-width: 768px) {
    .price {
      font-size: 2rem;
    }
  }

  .old-price {
    font-size: 1.125rem;
    color: #9ca3af;
    text-decoration: line-through;
  }

  .discount-info {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .original-price {
    font-size: 1.125rem;
    color: #9ca3af;
    text-decoration: line-through;
  }

  .discount-badge {
    padding: 0.25rem 0.5rem;
    background: rgba(220, 38, 38, 0.1);
    color: #dc2626;
    font-size: 0.75rem;
    font-weight: 600;
    border-radius: 0.25rem;
    border: 1px solid rgba(220, 38, 38, 0.2);
  }

  /* Benefits Strip */
  .benefits-strip {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.75rem;
    margin-bottom: 1.5rem;
  }

  .benefit-card {
    background: linear-gradient(135deg, rgba(107, 123, 92, 0.05) 0%, rgba(107, 123, 92, 0.1) 100%);
    border: 1px solid rgba(107, 123, 92, 0.1);
    border-radius: 0.75rem;
    padding: 1rem 0.75rem;
    text-align: center;
    transition: all 0.2s;
  }

  .benefit-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(107, 123, 92, 0.1);
  }

  .benefit-icon {
    width: 2.5rem;
    height: 2.5rem;
    margin: 0 auto 0.5rem;
    background: rgba(107, 123, 92, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 1.25rem;
      height: 1.25rem;
      color: var(--clr-olive, #6b7b5c);
    }
  }

  .benefit-title {
    font-size: 0.6875rem;
    font-weight: 600;
    color: #111718;
    line-height: 1.3;
  }

  @media (min-width: 768px) {
    .benefit-card {
      padding: 1.25rem 1rem;
    }

    .benefit-icon {
      width: 3rem;
      height: 3rem;
    }

    .benefit-title {
      font-size: 0.75rem;
    }
  }

  /* Product Specifications Card */
  .product-specs {
    background: rgba(245, 243, 240, 0.5);
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 1rem;
    padding: 1.25rem;
    margin-bottom: 1.5rem;
  }

  @media (min-width: 768px) {
    .product-specs {
      padding: 1.5rem;
    }
  }

  .specs-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .specs-icon {
    width: 2rem;
    height: 2rem;
    background: rgba(107, 123, 92, 0.1);
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 1rem;
      height: 1rem;
      color: var(--clr-olive, #6b7b5c);
    }
  }

  .specs-title {
    font-family: 'Playfair Display', serif;
    font-size: 1rem;
    font-weight: 700;
    color: #111718;
    margin: 0;
  }

  .spec-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .spec-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .spec-label {
    font-size: 0.875rem;
    color: #6b7280;
  }

  .spec-value {
    font-size: 0.875rem;
    font-weight: 500;
    color: #111718;

    &.in-stock {
      color: var(--clr-olive, #6b7b5c);
    }

    &.out-of-stock {
      color: #dc2626;
    }
  }

  .desc {
    font-size: 0.9375rem;
    line-height: 1.7;
    color: #6b7280;
    margin-bottom: 1.5rem;
  }

  .desc-html {
    font-size: 0.9375rem;
    line-height: 1.7;
    color: #6b7280;

    /* Quill direction & alignment classes */
    .ql-direction-rtl {
      direction: rtl;
      text-align: right;
    }
    .ql-align-center {
      text-align: center;
    }
    .ql-align-right {
      text-align: right;
    }
    .ql-align-justify {
      text-align: justify;
    }
    
    h1, h2, h3, h4, h5, h6 {
      color: #111718;
      font-family: 'Playfair Display', serif;
      margin-top: 1.5rem;
      margin-bottom: 0.75rem;
    }
    
    p {
      margin-bottom: 1rem;
    }

    ul, ol {
      margin-bottom: 1rem;
      padding-left: 2rem;
      
      li {
        margin-bottom: 0.5rem;
      }
    }

    img {
      max-width: 100%;
      height: auto;
      border-radius: 0.5rem;
      margin: 1rem 0;
    }

    a {
      color: var(--clr-olive, #6b7b5c);
      text-decoration: underline;
    }
  }

  /* Product Options */
  .product-options {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    margin-bottom: 1.5rem;
  }

  .option-group {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .option-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #111718;

    span {
      color: var(--clr-olive, #6b7b5c);
      font-weight: 600;
    }
  }

  /* Colors */
  .colors {
    display: flex;
    gap: 0.75rem;
  }

  .color-btn {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    border: 2px solid transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    svg {
      font-size: 0.875rem;
      color: #ffffff;
    }

    &:hover {
      transform: scale(1.1);
    }

    &.active {
      border-color: var(--clr-olive, #6b7b5c);
      box-shadow: 0 0 0 2px var(--clr-olive, #6b7b5c);
    }

    &.light-color svg {
      color: #374151;
    }

    /* Out of stock: diagonal strike line, dimmed, not selectable */
    &.out-of-stock {
      cursor: not-allowed;
      opacity: 0.45;
      position: relative;
      overflow: hidden;

      &:hover {
        transform: none;
      }

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: -10%;
        width: 120%;
        height: 2px;
        background: #ef4444;
        transform: rotate(-45deg);
        transform-origin: center;
        pointer-events: none;
      }
    }
  }

  /* Textual Variant Buttons (sizes, materials, etc.) */
  .variant-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .variant-btn {
    padding: 0.5rem 1.25rem;
    border: 1.5px solid #d1d5db;
    border-radius: 0.5rem;
    background: #ffffff;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: var(--clr-olive, #6b7b5c);
      color: var(--clr-olive, #6b7b5c);
    }

    &.active {
      background: var(--clr-olive, #6b7b5c);
      border-color: var(--clr-olive, #6b7b5c);
      color: #ffffff;
    }

    &.out-of-stock {
      cursor: not-allowed;
      opacity: 0.5;
      text-decoration: line-through;
      background: #f3f4f6;
      color: #9ca3af;
      border-color: #e5e7eb;

      &:hover {
        border-color: #e5e7eb;
        color: #9ca3af;
      }
    }
  }

  /* Dropdown Variant */
  .variant-dropdown {
    padding: 0.625rem 1rem;
    border: 1.5px solid #d1d5db;
    border-radius: 0.5rem;
    background: #ffffff;
    font-size: 0.875rem;
    color: #374151;
    cursor: pointer;
    outline: none;
    max-width: 16rem;
    transition: border-color 0.2s;

    &:focus {
      border-color: var(--clr-olive, #6b7b5c);
    }
  }

  /* Radio Variant Buttons */
  .variant-radios {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .variant-radio {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.5rem 1rem;
    border: 1.5px solid #d1d5db;
    border-radius: 0.5rem;
    background: #ffffff;
    font-size: 0.875rem;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s;

    input[type='radio'] {
      accent-color: var(--clr-olive, #6b7b5c);
      margin: 0;
    }

    &:hover {
      border-color: var(--clr-olive, #6b7b5c);
    }

    &.active {
      border-color: var(--clr-olive, #6b7b5c);
      background: rgba(107, 123, 92, 0.05);
    }
  }

  /* Offers Selection */
  .offers-group {
    margin-top: 0.5rem;
  }

  .offers-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .offer-wrapper {
    display: flex;
    flex-direction: column;
    border: 2px solid #e5e7eb;
    border-radius: 0.75rem;
    overflow: hidden;
    background: #ffffff;
    transition: all 0.2s ease;

    &.active {
      border-color: var(--clr-olive, #6b7b5c);
      box-shadow: 0 0 0 1px var(--clr-olive, #6b7b5c);
    }
  }

  .offer-card {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.875rem 1rem;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;

    input[type='radio'] {
      display: none;
    }

    &:hover {
      background: rgba(107, 123, 92, 0.02);
    }
  }

  .offer-wrapper.active .offer-card {
    background: rgba(107, 123, 92, 0.05);
  }

  .offer-internal-variants {
    padding: 1rem;
    border-top: 1px solid #e5e7eb;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .inside-offer .compact-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    background: #fafafa;
  }

  .variant-item-label {
    font-size: 0.85rem;
    color: var(--clr-olive, #6b7b5c);
    font-weight: 700;
    margin: 0;
    min-width: 25px;
  }

  .flex-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
    flex: 1;
  }

  .compact-option-group {
    display: flex;
    align-items: center;
  }

  .compact-colors {
    display: flex;
    gap: 0.35rem;
    align-items: center;
  }

  .color-btn-small {
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0;
    transition: all 0.2s;

    &.active {
      box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--clr-olive, #6b7b5c);
      transform: scale(1.1);
    }

    &.light-color {
      border: 1px solid #cbd5e1;
    }

    svg {
      font-size: 0.7rem;
      color: #ffffff;
    }

    &.light-color svg {
      color: #111718;
    }

    &.out-of-stock {
      cursor: not-allowed;
      opacity: 0.45;
      overflow: hidden;

      &:hover {
        transform: none;
      }

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: -10%;
        width: 120%;
        height: 1.5px;
        background: #ef4444;
        transform: rotate(-45deg);
        transform-origin: center;
        pointer-events: none;
      }
    }
  }

  .compact-variant-dropdown {
    padding: 0.4rem 0.5rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.375rem;
    font-size: 0.85rem;
    background-color: #fff;
    cursor: pointer;
    color: #111718;
    height: 34px;
    min-width: 100px;
    max-width: 160px;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: var(--clr-olive, #6b7b5c);
    }
  }

  .offer-content {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0.75rem;
    }

    .offer-description {
      font-size: 0.875rem;
      font-weight: 600;
      color: #111718;
      flex: 1;
    }

    .offer-pricing {
      text-align: right;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 0.125rem;
    }

    .offer-price {
      font-size: 1rem;
      font-weight: 700;
      color: var(--clr-olive, #6b7b5c);
    }

    .offer-shipping {
      font-size: 0.75rem;
      color: #6b7280;
      font-weight: 400;
    }

    .offer-check {
      width: 1.5rem;
      height: 1.5rem;
      border-radius: 50%;
      border: 2px solid #d1d5db;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: all 0.2s;

      svg {
        font-size: 0.65rem;
        color: #ffffff;
      }
    }

    &.active .offer-check {
      background: var(--clr-olive, #6b7b5c);
      border-color: var(--clr-olive, #6b7b5c);
    }
  }

  .summary-row.offer-row {
    .label {
      color: var(--clr-olive, #6b7b5c) !important;
      font-weight: 600 !important;
      font-size: 0.8125rem;
    }
    .value {
      color: var(--clr-olive, #6b7b5c) !important;
    }
  }

  @media (max-width: 480px) {
    .offer-card {
      padding: 0.75rem;

      .offer-content {
        flex-direction: column;
        align-items: flex-start;
      }

      .offer-pricing {
        align-items: flex-start;
      }
    }
  }

  /* Quantity */
  .quantity-selector {
    display: flex;
    align-items: center;
    width: fit-content;
    border: 1px solid #e5e7eb;
    border-radius: 0.75rem;
    background: #ffffff;
    overflow: hidden;
  }

  .qty-btn {
    width: 3rem;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    font-size: 1.25rem;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #f3f4f6;
      color: var(--clr-olive, #6b7b5c);
    }
  }

  .qty-value {
    width: 3rem;
    text-align: center;
    font-size: 1rem;
    font-weight: 600;
    color: #111718;
  }

  /* Customer Form */
  .customer-form {
    background: linear-gradient(135deg, #f9fafb 0%, #f5f3f0 100%);
    padding: 1.25rem;
    border-radius: 1rem;
    margin-bottom: 1.5rem;
    border: 1px solid rgba(0, 0, 0, 0.06);

    h4 {
      font-family: 'Playfair Display', serif;
      font-size: 1.125rem;
      font-weight: 700;
      color: #111718;
      margin: 0 0 1rem;
    }
  }

  @media (min-width: 768px) {
    .customer-form {
      padding: 1.5rem;
    }
  }

  .form-grid {
    display: grid;
    gap: 1rem;
  }

  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
  }

  @media (max-width: 576px) {
    .form-row {
      grid-template-columns: 1fr;
    }
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;

    label {
      font-size: 0.75rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: #6b7280;
    }

    input, select {
      width: 100%;
      padding: 0.75rem 1rem;
      background: #ffffff;
      border: 1px solid #e5e7eb;
      border-radius: 0.5rem;
      font-size: 0.875rem;
      color: #111718;
      transition: all 0.2s;

      &:focus {
        outline: none;
        border-color: var(--clr-olive, #6b7b5c);
        box-shadow: 0 0 0 3px rgba(107, 123, 92, 0.1);
      }

      &::placeholder {
        color: #9ca3af;
      }
    }
  }

  /* Action Buttons */
  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .order-now-btn {
    width: 100%;
    padding: 1rem 1.5rem;
    background: #111718;
    color: #ffffff;
    font-size: 1rem;
    font-weight: 600;
    border: none;
    border-radius: 0.75rem;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 4px 12px rgba(17, 23, 24, 0.15);

    &:hover {
      background: #000000;
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(17, 23, 24, 0.2);
    }

    &:disabled {
      background: #9ca3af;
      cursor: not-allowed;
      box-shadow: none;
      transform: none;
    }
  }

  .add-cart-btn {
    width: 100%;
    padding: 1rem 1.5rem;
    background: transparent;
    color: var(--clr-olive, #6b7b5c);
    font-size: 1rem;
    font-weight: 600;
    border: 2px solid var(--clr-olive, #6b7b5c);
    border-radius: 0.75rem;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: var(--clr-olive, #6b7b5c);
      color: #ffffff;
    }
  }

  .price-summary {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 0.75rem;
    padding: 1rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    .summary-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.75rem;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        font-size: 0.875rem;
        color: #4b5563;
        font-weight: 500;
      }

      .value {
        font-size: 0.9375rem;
        color: #111718;
        font-weight: 600;
      }

      &.total {
        .label {
          font-size: 1rem;
          color: #111718;
          font-weight: 700;
        }

        .value {
          font-size: 1.125rem;
          color: var(--clr-olive, #6b7b5c);
          font-weight: 700;
        }
      }
    }

    .summary-divider {
      height: 1px;
      background: #e5e7eb;
      margin: 0.75rem 0;
    }
  }

  /* Why Choose Section */
  .why-choose-section {
    background: linear-gradient(180deg, #f5f3f0 0%, var(--clr-background, #f6f8f8) 100%);
    padding: 4rem 0;
    position: relative;
    overflow: hidden;
  }

  .why-choose-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 16rem;
    height: 16rem;
    background: rgba(107, 123, 92, 0.05);
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }

  .why-choose-section::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 24rem;
    height: 24rem;
    background: rgba(201, 169, 98, 0.05);
    border-radius: 50%;
    transform: translate(50%, 50%);
  }

  .why-choose-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1.5rem;
    position: relative;
    z-index: 1;
  }

  .section-header {
    text-align: center;
    margin-bottom: 3rem;
  }

  .section-badge {
    display: inline-block;
    padding: 0.5rem 1rem;
    background: rgba(107, 123, 92, 0.1);
    color: var(--clr-olive, #6b7b5c);
    font-size: 0.875rem;
    font-weight: 600;
    border-radius: 9999px;
    margin-bottom: 1rem;
  }

  .section-title {
    font-family: 'Playfair Display', serif;
    font-size: 1.75rem;
    font-weight: 700;
    color: #111718;
    margin: 0;

    span {
      color: var(--clr-olive, #6b7b5c);
    }
  }

  @media (min-width: 768px) {
    .section-title {
      font-size: 2.25rem;
    }
  }

  .why-choose-grid {
    display: grid;
    gap: 1.5rem;
  }

  @media (min-width: 768px) {
    .why-choose-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .reason-card {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 1rem;
    padding: 2rem 1.5rem;
    text-align: center;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  .reason-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
  }

  .reason-icon {
    width: 4rem;
    height: 4rem;
    margin: 0 auto 1.25rem;
    background: linear-gradient(135deg, rgba(107, 123, 92, 0.1) 0%, rgba(107, 123, 92, 0.2) 100%);
    border-radius: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    svg {
      width: 2rem;
      height: 2rem;
      color: var(--clr-olive, #6b7b5c);
      transition: color 0.3s;
    }
  }

  .reason-card:hover .reason-icon {
    background: var(--clr-olive, #6b7b5c);

    svg {
      color: #ffffff;
    }
  }

  .reason-title {
    font-family: 'Playfair Display', serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: #111718;
    margin: 0 0 0.75rem;
  }

  .reason-description {
    font-size: 0.9375rem;
    line-height: 1.6;
    color: #6b7280;
    margin: 0;
  }

  /* Reviews Section */
  .reviews-section {
    background: var(--clr-background, #f6f8f8);
    padding: 4rem 0;
  }

  .reviews-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1.5rem;
  }

  .reviews-header {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-bottom: 2.5rem;

    @media (min-width: 1024px) {
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;
    }

    h3 {
      font-family: 'Playfair Display', serif;
      font-size: 1.75rem;
      font-weight: 700;
      color: #111718;
      margin: 0 0 0.5rem;

      span {
        color: var(--clr-olive, #6b7b5c);
      }

      @media (min-width: 768px) {
        font-size: 2rem;
      }
    }

    .reviews-summary {
      display: flex;
      align-items: center;
      gap: 1.5rem;

      .rating-block {
        text-align: center;
        padding-right: 1.5rem;
        border-right: 1px solid #e5e7eb;
      }

      .stars {
        display: flex;
        gap: 0.125rem;
        color: #C9A962;
        font-size: 1.125rem;
        justify-content: center;
        margin-bottom: 0.25rem;
      }

      .rating-value {
        font-family: 'Playfair Display', serif;
        font-size: 1.5rem;
        font-weight: 700;
        color: #111718;
      }

      .review-count {
        font-size: 0.875rem;
        color: #6b7280;
      }
    }
  }

  .write-review-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.25rem;
    background: transparent;
    color: var(--clr-olive, #6b7b5c);
    font-size: 0.875rem;
    font-weight: 600;
    border: 1px solid var(--clr-olive, #6b7b5c);
    border-radius: 0.5rem;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s;

    &:hover {
      background: var(--clr-olive, #6b7b5c);
      color: #ffffff;
    }
  }

  .reviews-grid {
    display: grid;
    gap: 1.5rem;
  }

  @media (min-width: 768px) {
    .reviews-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 1024px) {
    .reviews-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .review-card {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 1rem;
    padding: 1.5rem;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
    }
  }

  .quote-icon {
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 1.5rem;
    color: rgba(107, 123, 92, 0.1);
    transition: color 0.3s;
  }

  .review-card:hover .quote-icon {
    color: rgba(107, 123, 92, 0.2);
  }

  .review-author {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1rem;

    img {
      width: 3rem;
      height: 3rem;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid rgba(107, 123, 92, 0.2);
    }

    .author-info {
      flex: 1;

      h4 {
        font-size: 0.9375rem;
        font-weight: 600;
        color: #111718;
        margin: 0 0 0.25rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }

      .verified-badge {
        display: inline-flex;
        align-items: center;
        gap: 0.25rem;
        padding: 0.125rem 0.5rem;
        background: rgba(107, 123, 92, 0.1);
        color: var(--clr-olive, #6b7b5c);
        font-size: 0.625rem;
        font-weight: 600;
        border-radius: 9999px;
      }

      .author-rating {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        .stars {
          display: flex;
          gap: 0.0625rem;
          color: #C9A962;
          font-size: 0.75rem;
        }

        .date {
          font-size: 0.75rem;
          color: #9ca3af;
        }
      }
    }
  }

  .review-text {
    font-size: 0.9375rem;
    line-height: 1.6;
    color: #6b7280;
    margin: 0 0 1rem;
    flex: 1;
  }

  .review-image {
    margin-top: auto;
    padding-top: 1rem;
    border-top: 1px solid rgba(0, 0, 0, 0.04);

    .image-label {
      display: flex;
      align-items: center;
      gap: 0.25rem;
      font-size: 0.75rem;
      color: #9ca3af;
      margin-bottom: 0.5rem;
    }

    img {
      width: 5rem;
      height: 5rem;
      border-radius: 0.5rem;
      object-fit: cover;
      border: 1px solid rgba(0, 0, 0, 0.06);
    }
  }

  .no-reviews {
    text-align: center;
    padding: 3rem;
    color: #6b7280;
    font-size: 1rem;
  }

  .review-modal-btn {
    margin-top: 2rem;
    text-align: center;
  }

  /* Out of stock message */
  .out-of-stock-message {
    padding: 2rem;
    background: rgba(220, 38, 38, 0.05);
    border: 1px solid rgba(220, 38, 38, 0.1);
    border-radius: 1rem;
    text-align: center;
    color: #dc2626;
    font-weight: 500;
  }

  /* Mobile Sticky CTA */
  .mobile-sticky-cta {
    display: none;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    padding: 1rem 1.5rem;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
    z-index: 100;
    border-top: 1px solid #e5e7eb;

    .sticky-content {
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    .sticky-price {
      font-family: 'Playfair Display', serif;
      font-size: 1.25rem;
      font-weight: 700;
      color: var(--clr-olive, #6b7b5c);
    }

    .sticky-btn {
      flex: 1;
      padding: 0.875rem 1rem;
      background: #111718;
      color: #ffffff;
      font-size: 0.9375rem;
      font-weight: 600;
      border: none;
      border-radius: 0.5rem;
      cursor: pointer;
    }
  }

  @media (max-width: 767px) {
    .mobile-sticky-cta {
      display: block;
    }

    .product-section {
      padding-bottom: 6rem;
    }
  }

  /* Zoom button on main image */
  .zoom-btn {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    z-index: 11;
    width: 2.25rem;
    height: 2.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(4px);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.2s;

    svg {
      font-size: 0.875rem;
      color: #6b7280;
    }

    &:hover {
      transform: scale(1.1);
      background: #fff;
    }
  }

  /* Lightbox Overlay */
  .lightbox-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.2s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .lightbox-container {
    position: relative;
    width: 90vw;
    max-width: 900px;
    max-height: 90vh;
    background: #fff;
    border-radius: 1rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  }

  .lightbox-close {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    z-index: 10;
    width: 2.25rem;
    height: 2.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.06);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s;

    svg {
      font-size: 1rem;
      color: #333;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.12);
    }
  }

  .lightbox-body {
    display: flex;
    flex-direction: row;
    height: 80vh;
    max-height: 80vh;
  }

  .lightbox-main {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f9f9f9;
    min-width: 0;
  }

  .lightbox-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  video.lightbox-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #000;
  }

  .lightbox-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.2s;
    z-index: 5;

    svg {
      font-size: 0.875rem;
      color: #333;
    }

    &:hover {
      background: #fff;
      transform: translateY(-50%) scale(1.1);
    }
  }

  .lightbox-prev {
    left: 0.75rem;
  }

  .lightbox-next {
    right: 0.75rem;
  }

  .lightbox-thumbs {
    width: 100px;
    overflow-y: auto;
    padding: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    background: #fff;
    border-left: 1px solid #eee;

    scrollbar-width: thin;
    scrollbar-color: rgba(0,0,0,0.1) transparent;

    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0,0,0,0.1);
      border-radius: 3px;
    }
  }

  .lightbox-thumb {
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    border-radius: 0.375rem;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid transparent;
    opacity: 0.6;
    transition: all 0.2s;
    flex-shrink: 0;

    img, video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .play-overlay {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 1rem;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &:hover {
      opacity: 1;
    }

    &.active {
      border-color: var(--clr-olive, #6b7b5c);
      opacity: 1;
      box-shadow: 0 0 0 1px var(--clr-olive, #6b7b5c);
    }
  }

  @media (max-width: 767px) {
    .lightbox-body {
      flex-direction: column;
    }

    .lightbox-thumbs {
      width: 100%;
      flex-direction: row;
      overflow-x: auto;
      overflow-y: hidden;
      border-left: none;
      border-top: 1px solid #eee;
      padding: 0.5rem;
    }

    .lightbox-thumb {
      width: 56px;
      min-width: 56px;
      height: 56px;
    }

    .lightbox-container {
      width: 95vw;
      max-height: 95vh;
    }

    .lightbox-main {
      min-height: 50vh;
    }
  }
`;

export default Wrapper;
